import { DASHBOARD, DASHBOARD_FINTECH } from '../../Helper/actionsTypes'
const DashReducer = (state = [], action) => {
    if (action.type === DASHBOARD) {
        return action.payload.code === 200
            ? { ...state, Ddetails: action.payload.results } : { ...state, Ddetails: '' }
    }
    if (action.type === DASHBOARD_FINTECH) {
        return action.payload.code === 200
            ? { ...state, FintechDetails: action.payload.results } : { ...state, FintechDetails: '' }
    }
    return state;
}
export default DashReducer